import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { Tooltip } from '@mui/material';
import React from 'react';
import { PREMIUM_FEATURE_TOOLTIP } from '../helpers/subscription';

export default function PremiumFeatureBadge({ sx }) {
    return (
        <Tooltip title={PREMIUM_FEATURE_TOOLTIP} arrow>
            <WorkspacePremiumIcon
                fontSize="small"
                sx={{ color: 'warning.main', ml: 0.75, verticalAlign: 'middle', ...sx }}
            />
        </Tooltip>
    );
}
